import { render, staticRenderFns } from "./BVlayout.vue?vue&type=template&id=7617fcc9&"
import script from "./BVlayout.vue?vue&type=script&lang=ts&"
export * from "./BVlayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports